export default __webpack_public_path__ + "static/media/docker.1f8d4da0.svg";